<template>
  <div :id="`modal-${modalId}`">
    <MadModal
      :id="modalId"
      :data-cy="`${modalId}-modal`"
      :options="options"
      @opened="onOpened"
      @closed="onClosed"
    >
      <div class="modal-body">
        <b-tabs
          v-model="tabIndex"
          no-key-nav
        >
          <template>
            <b-tab :title="`${this.$i18n.t('JSON.wikipedia-pages')}`">
              <div class="v-table">
                <TableServer type="wikipediaPages" />
              </div>
            </b-tab>
            <b-tab :title="`${this.$i18n.t('JSON.wikipedia-tables')}`">
              <div class="v-table">
                <TableServer type="wikipediaTables" />
              </div>
            </b-tab>
            <b-tab :title="`${this.$i18n.t('JSON.add-wikipedia-page')}`">
              <WikipediaPageForm v-if="fetcherAdminSchemas.forms['WikipediaPage']" />
            </b-tab>
            <b-tab :title="`${this.$i18n.t('JSON.add-wikipedia-table')}`">
              <WikipediaTableForm v-if="fetcherAdminSchemas.forms['WikipediaTable']" />
            </b-tab>
            <b-tab
              v-if="wikipediaPageId !== null && adminWikipediaPage.id > 0"
              :title="`${this.$i18n.t('JSON.wikipedia-page')}#${wikipediaPageId}`"
            >
              <WikipediaPageForm
                v-if="fetcherAdminSchemas.forms['WikipediaPage']"
                :wikipedia-page="adminWikipediaPage"
                mode="edit"
              />
            </b-tab>
            <b-tab
              v-if="wikipediaTableId !== null && adminWikipediaTable.id > 0"
              :title="`${this.$i18n.t('JSON.wikipedia-table')}#${wikipediaTableId}`"
            >
              <WikipediaTableForm
                v-if="fetcherAdminSchemas.forms['WikipediaTable']"
                :wikipedia-table="adminWikipediaTable"
                mode="edit"
              />
            </b-tab>
          </template>
        </b-tabs>
      </div>
    </MadModal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import formHelpers from '@/mixins/admin/helpers/form-helpers';
import modalHelpers from '@/mixins/admin/helpers/modal-helpers';

export default {

  components: {
    MadModal: () => import('@/components/MadModal'),
    WikipediaPageForm: () => import('@/components/admin/fetcher/modals/forms/WikipediaPageForm'),
    WikipediaTableForm: () => import('@/components/admin/fetcher/modals/forms/WikipediaTableForm'),
  },

  mixins: [
    formHelpers, //
    modalHelpers,
  ],

  props: {
    wikipediaPageId: {
      type: Number,
      default: () => 0,
    },
    wikipediaTableId: {
      type: Number,
      default: () => 0,
    },
  },

  data() {
    return {
      options: {
        width: '75%',
        //   height: '95%',
      },
    };
  },

  computed: {
    ...mapState({
      adminWikipediaPage: (state) => state.adminWikipediaPage.adminWikipediaPage,
      adminWikipediaTable: (state) => state.adminWikipediaTable.adminWikipediaTable,
    }),

    modalId() {
      return 'wikipedia';
    },
  },

  watch: {
    wikipediaPageId(newValue) {
      if (newValue !== null) {
        this.loadFetcherAdminWikipediaPage();
      }
    },

    wikipediaTableId(newValue) {
      if (newValue !== null) {
        this.loadFetcherAdminWikipediaTable();
      }
    },
  },

  methods: {
    ...mapActions(['getFetcherAdminWikipediaPage', 'getWikipediaTable']),

    async loadFetcherAdminWikipediaPage() {
      try {
        await this.getFetcherAdminWikipediaPage({
          params: {
            wpid: this.wikipediaPageId,
          },
        });

        // console.log('wikipedia-page', this.wikipedia-page);

        // success
        // console.log('success loading wikipedia-page!');
      } catch (error) {
        // error
        // console.log('error loading wikipedia-page!');
      }
    },

    async loadFetcherAdminWikipediaTable() {
      try {
        await this.getFetcherAdminWikipediaTable({
          params: {
            wtid: this.wikipediaTableId,
          },
        });

        // console.log('wikipediaTable', this.wikipediaTable);

        // success
        // console.log('success loading wikipediaTable!');
      } catch (error) {
        // error
        // console.log('error loading wikipediaTable!');
      }
    },

    onOpened() {
      if (this.wikipediaPageId !== null) {
        this.loadFetcherAdminWikipediaPage();
      }

      if (this.wikipediaTableId !== null) {
        this.loadFetcherAdminWikipediaTable();
      }

      this.modalOpened();
    },

    onClosed() {
      this.modalClosed();
    },
  },
};
</script>
